export type LegalDocument = {
  path: string;
  title: string;
  mobileTitleLines: string[];
  helmetTitle: string;
  helmetDescription: string;
  iframeTitle: string;
  publishedUrl: string;
  showDownloads: boolean;
  googleDocId?: string;
};

export const toEmbeddedUrl = (publishedUrl: string): string => {
  const url = new URL(publishedUrl);
  url.searchParams.set('embedded', 'true');
  return url.toString();
};

export const toPdfExportUrl = (googleDocId: string): string =>
  `https://docs.google.com/document/d/${googleDocId}/export?format=pdf`;

export const toDocxExportUrl = (googleDocId: string): string =>
  `https://docs.google.com/document/d/${googleDocId}/export?format=docx`;

export const LEGAL_DOCUMENTS = {
  servicesAgreement: {
    path: '/services-agreement',
    title: 'Playcast Services Agreement',
    mobileTitleLines: ['Playcast', 'Services', 'Agreement'],
    helmetTitle: 'Services Agreement | Playcast',
    helmetDescription: 'Playcast Services Agreement — terms governing the use of Playcast services.',
    iframeTitle: 'Playcast Services Agreement',
    publishedUrl:
      'https://docs.google.com/document/d/e/2PACX-1vS3TfbW9L5raKFB6FTKDZumK6kg8n9FhB007LCyXM8MvtphGRSCFm1K6BFEyA62LA/pub',
    showDownloads: true,
    googleDocId: '1kBEBd7pCi4jimxNIm2ZSmsdM14mUXQBP',
  },
  privacyPolicy: {
    path: '/privacy-policy',
    title: 'Playcast Privacy Policy',
    mobileTitleLines: ['Playcast', 'Privacy', 'Policy'],
    helmetTitle: 'Privacy Policy | Playcast',
    helmetDescription: 'Playcast Privacy Policy — how we collect, use, and protect personal information.',
    iframeTitle: 'Playcast Privacy Policy',
    publishedUrl:
      'https://docs.google.com/document/d/e/2PACX-1vQ-eYSuWMCQEXS2jXQ296mup8DmQRjb9teq0uZto1rw9L4jWXKTT6qu29GRXgwymaaqUrjGksbgM0lQ/pub',
    showDownloads: false,
  },
  termsOfService: {
    path: '/terms-of-service',
    title: 'Playcast Terms of Service',
    mobileTitleLines: ['Playcast', 'Terms of', 'Service'],
    helmetTitle: 'Terms of Service | Playcast',
    helmetDescription: 'Playcast Terms of Service — rules that govern use of Playcast websites, applications, and services.',
    iframeTitle: 'Playcast Terms of Service',
    publishedUrl:
      'https://docs.google.com/document/d/e/2PACX-1vSMqEbw1YFOYmmx0AjyMcaxHpdkiA1CGS_W9RW9U7ypxLlP6yEqLxUAJclxdfxs15-BCF5-eQQLOvIx/pub',
    showDownloads: false,
  },
  eula: {
    path: '/eula',
    title: 'Playcast End User License Agreement',
    mobileTitleLines: ['Playcast', 'End User', 'License Agreement'],
    helmetTitle: 'End User License Agreement | Playcast',
    helmetDescription:
      'Playcast End User License Agreement (EULA) — terms for downloading, installing, and using the Playcast application.',
    iframeTitle: 'Playcast End User License Agreement',
    publishedUrl:
      'https://docs.google.com/document/d/e/2PACX-1vTfudMU6TIsrJ30fDEL7zfezskayJabyVKjBjj8L95bblcLIRb0myYP3qCwP4COTuw3IAxpPediMLUR/pub',
    showDownloads: false,
  },
} satisfies Record<string, LegalDocument>;

export const LEGAL_DOCUMENT_PATHS: string[] = Object.values(LEGAL_DOCUMENTS).map((document) => document.path);

export const isLegalDocumentPath = (pathname: string): boolean => {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return LEGAL_DOCUMENT_PATHS.includes(normalized);
};
